export const easeOutExpo = [0.16, 1, 0.3, 1];
export const easeInOut = [0.65, 0, 0.35, 1];

export const fadeUp = {
  hidden: { y: 24, opacity: 0 },
  show: (i = 0) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.9, delay: i * 0.06, ease: easeOutExpo },
  }),
};

export const stagger = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.08 },
  },
};

export const maskReveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 1.1, delay: i * 0.08, ease: easeOutExpo },
  }),
};

export const inViewOnce = { once: true, amount: 0.2 };
